import { AxiosError } from 'axios';
import { baseService } from 'services';
import { commonError, createInstallationEP } from './constants';
import { IErrorResponse, ISuccessResponse } from 'interface/apiInterface';
import {
  IAddInstallationIDToOrg,
  IAddInstallationIDToOrgResponse,
} from 'interface/installationInterface';

export const createInstallationService = async (
  data: IAddInstallationIDToOrg,
): Promise<
  ISuccessResponse<IAddInstallationIDToOrgResponse> | IErrorResponse<AxiosError>
> => {
  try {
    const response = await baseService.post(createInstallationEP, data);
    return response;
  } catch (error) {
    return commonError(error as AxiosError, true);
  }
};
